<template>
  <div>
    <!-- 功能开发中 -->
    <el-dialog class="dialog-single-one" center :visible="dialogVisable1" :show-close="false">
      <img src="../../assets/images/development.png" alt="" style="width:120px;height:110px;">
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Development",
  props: ["dialogVisable1"],
  data () {
    return {
      dialogVisable1: false,
    }
  },

}
</script>

<style lang="less" scoped>
</style>
